import { NavLink, Route, Routes } from "react-router-dom";

function Main() {
  return (
    <>
      <div className="col-xl-6 mx-auto">
        <div className="row mx-2">
          <h4>Welcome to Doctor Patient Interface!</h4>
        </div>
        <div className="row">
          <div class="col-lg-7">
            <div className="card mb-4">
              <div className="card-body">
                Doctor Patient Interface(DPI) helps doctors to record medical
                condition of a patient based on predefined templates. DPI
                provides flexibility to capture data in a template form, that
                can easily be modified based on user needs. DPI provides an
                ideal environment where Doctors can analyze gathered data in a
                desired graphical form. It gives an option to users to download
                the patients data in different desired formats. Doctors can
                design surveys and circulate among selected users. It provides a
                user interface where survey initiator can monitor the survey
                data in a graphical form.
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div className="card mb-4">
              <div className="card-body">
                <b>Doctor Patient Interface(DPI) Features</b>
                <hr></hr>
                <ul>Build Custom Templates</ul>
                medical condition of a patient based on predefined templates.
                DPI gives a flexiblity to its users to capture data in a
                template that can easily be modified based on user needs.
                doctors to analyze history cases based on collected patient’s
                data. It creates an interface between medical staff, patients
                and patients attendants.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Main;
